import wasmURL from '@ffmpeg/core/wasm?url';
import coreURL from '@ffmpeg/core?url';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

export const ffmpegOptions = (
  inputFileName: string,
  outputFileName: string,
) => [
  // Manter mensagens de erro, mas remover igndts
  '-fflags',
  '+genpts', // Remova +igndts
  '-err_detect',
  'ignore_err',
  // Input file
  '-i',
  inputFileName,
  // Adicionar controle de framerate
  '-r',
  '15', // Ou o framerate original do vídeo
  // Vídeo codec
  '-c:v',
  'h264',
  '-crf',
  '23',
  // Manter configurações de velocidade
  '-tune',
  'fastdecode',
  // Adicionar sincronização de vídeo
  '-vsync',
  '1',
  // Áudio codec
  '-c:a',
  'aac',
  '-b:a',
  '128k',
  '-preset',
  'ultrafast',
  '-f',
  'mp4',
  outputFileName,
];

const ffmpeg = new FFmpeg();

const loadFFmpeg = async (ffmpeg: FFmpeg) => {
  await ffmpeg.load({
    coreURL,
    wasmURL,
  });
};

export const isVideoFile = (file: File): boolean =>
  file.type.startsWith('video/');

export const convertVideo = async (
  file: File,
  fileName: string,
  onProgress?: (progress: number) => void,
) => {
  if (!isVideoFile(file)) return file;

  if (!ffmpeg.loaded) {
    await loadFFmpeg(ffmpeg);
  }

  if (onProgress) {
    ffmpeg.on('progress', ({ time }) => {
      onProgress(Math.round(time / 1000));
    });
  }

  await ffmpeg.writeFile(file.name, await fetchFile(file));
  await ffmpeg.exec(ffmpegOptions(file.name, fileName));
  const fileData = await ffmpeg.readFile(fileName);
  return new File([fileData], fileName, {
    type: 'video/mp4',
    lastModified: Date.now(),
  });
};
